import React from "react";

// Example tracking data (replace with your props)

const statusColor = {
  completed: "bg-green-100 text-green-700",
  inProgress: "bg-yellow-100 text-yellow-700",
  failed: "bg-red-100 text-red-700",
};

export const TrackingCard = ({ data }) => (
  <div className="text-white rounded-xl overflow-hidden p-6">
    <div className="flex items-center justify-between mb-4">
      <h2 className="text-lg font-semibold">Tracking Status</h2>
      <span
        className={`px-3 py-1 rounded-full text-sm font-medium ${
          statusColor[data.status] || "bg-gray-100 text-gray-700"
        }`}
      >
        {data.status}
      </span>
    </div>
    <div className="mb-2 flex justify-between">
      <span className="font-medium">Step:</span>
      <span>{data.step}</span>
    </div>
    <div className="mb-2 flex justify-between">
      <span className="font-medium">Last Step Status:</span>
      <span>{data.lastStepStatus}</span>
    </div>
    <div className="mb-2 flex justify-between">
      <span className="font-medium">Last Updated at:</span>
      <span>{data.updated}</span>
    </div>
    {/* Optionally, show other fields */}
    <div className="text-sm text-gray-500 mt-4">
      WhatsApp ID: {data.whatsappBusinessId}
    </div>
    <div className="text-sm text-gray-500">
      Meta Business ID: {data.metaBusinessId}
    </div>
    <div className="text-sm text-gray-500">
      Phone Number ID: {data.phoneNumberId}
    </div>
    {data.reason && (
      <div className="mt-4 text-sm text-red-600">Reason: {data.reason}</div>
    )}

    <div className="bg-[#fff3cd] border-1 border-[#ffeeba] mt-10 p-1 text-xs rounded-lg w-fit">
      <p className="text-[#856404]">Please contact admin for more info.</p>
    </div>
  </div>
);
